module.exports = __webpack_public_path__ + "img/b28c1c9.png";